import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import * as yup from 'yup'
import { Button, ErrorText, Form, PasswordField } from '../components'
import * as networkService from '../services/networkService'
import * as routeService from '../services/routeService'
import * as translationService from '../services/translationService'
import { ERROR_PASSWORD_REGEX } from './../utils/validation/constants'
import AuthContent from './AuthContent'

const mapStateToProps = state => {
  const { AuthReducer, FlowReducer } = state
  const { user = {}, error } = AuthReducer
  const { property } = FlowReducer
  const { mobileNumber, id } = user
  return {
    mobileNumber,
    property,
    id,
    error,
  }
}

class ResetPasswordView extends React.Component {
  static propTypes = {
    match: PropTypes.any,
    property: PropTypes.any,
  }

  state = {
    newPassword: '',
    error: null,
    mainError: null,
  }

  handleChange = ({ target: { id, value } }) => {
    this.setState({
      [id]: value,
    })
  }

  componentDidMount() {
    networkService.resetPassword('', this.props.match.params.resetToken).catch(error => {
      if (error.request.status === 401) {
        this.setState({ mainError: translationService.passwordResetTokenExpired() })
      }
    })
  }

  handleSubmit = async event => {
    if (event) event.preventDefault()
    const { newPassword } = this.state

    yup
      .string()
      .matches(new RegExp(`${translationService.loginPasswordRegex()}`, 'g'), ERROR_PASSWORD_REGEX)
      .validate(newPassword)
      .then(() => networkService.resetPassword(this.state.newPassword, this.props.match.params.resetToken))
      .then(() => routeService.goToResetPasswordSuccessPage())
      .catch(error => {
        if (error.request && error.request.status === 401) {
          this.setState({ mainError: translationService.passwordResetTokenExpired() })
        } else {
          this.setState({ error: error.message })
        }
      })
  }

  goToPasswordReset = event => {
    event.preventDefault()
    routeService.goToLoginPage()
  }

  render() {
    const { error, newPassword, mainError } = this.state
    return (
      <AuthContent
        title={translationService.passwordResetTitle()}
        subtitle={translationService.passwordResetIntro()}
        hasToken={false}>
        <Form onSubmit={this.handleSubmit}>
          {mainError && (
            <React.Fragment>
              <ErrorText>{mainError}</ErrorText>
              <div>
                <Button plain onClick={this.goToPasswordReset}>
                  {translationService.passwordResetPasswordRequestAgain()}
                </Button>
              </div>
            </React.Fragment>
          )}

          {!mainError && (
            <React.Fragment>
              <PasswordField
                label={translationService.passwordResetPasswordLabel()}
                id="newPassword"
                value={newPassword}
                onChange={this.handleChange}
                helpText={translationService.loginPasswordRequirements()}
                error={error && error}
              />
              <Button primary submit onClick={this.handleSubmit}>
                {translationService.passwordResetButton()}
              </Button>
            </React.Fragment>
          )}
        </Form>
      </AuthContent>
    )
  }
}

export default compose(
  translate('translations'),
  connect(mapStateToProps),
)(ResetPasswordView)



// WEBPACK FOOTER //
// ./src/views/ResetPasswordView.js